export default __webpack_public_path__ + "static/big-data-business-intelligence-sfruttare-i-dati-6fee9b104adcb67babefea63d3b9626c.jpg";